import React from "react";
import { UserOutlined } from '@ant-design/icons';
import LeedflowLogoMinimalist from '../../../assets/images/logo/logo-leedflow-minimalist.png';
import { EProductType } from '../Plan/EProductType';
import { UserRole, userRoleAsString } from './UserRole';

export const renderUserRoleOption = (role: UserRole | string): React.ReactNode => {
  switch (role) {
    case UserRole.owner:
      return <><img src={LeedflowLogoMinimalist} alt={EProductType.LEEDFLOW} style={{ marginRight: 6, height: '18px' }} /> {userRoleAsString(role)}</>;
    case UserRole.admin:
      return <><img src={LeedflowLogoMinimalist} alt={EProductType.LEEDFLOW} style={{ marginRight: 6, height: '18px' }} /> {userRoleAsString(role)}</>;
    case UserRole.maintainer:
      return <><img src={LeedflowLogoMinimalist} alt={EProductType.LEEDFLOW} style={{ marginRight: 6, height: '18px' }} /> {userRoleAsString(role)}</>;
    case UserRole.guest:
      return <><img src={LeedflowLogoMinimalist} alt={EProductType.LEEDFLOW} style={{ marginRight: 6, height: '18px' }} /> {userRoleAsString(role)}</>;
    case UserRole.customer:
      return <><UserOutlined style={{ marginRight: 6 }} /> {userRoleAsString(role)}</>;
    default:
      return userRoleAsString(role);
  }
};
